module.exports = __webpack_public_path__ + "static/media/WorldView(5).6e06eadb.jpg";